import { useEffect, useState } from "react";
import * as THREE from "three";

const FallbackMaterial = ({ side }) => (
  <meshStandardMaterial color="#1a1a1a" side={side} toneMapped={false} />
);

const ImageWallMaterialInner = ({ src, side }) => {
  const [texture, setTexture] = useState(null);

  useEffect(() => {
    if (!src) return;

    const loader = new THREE.TextureLoader();
    loader.crossOrigin = "anonymous";

    const tex = loader.load(
      src,
      (loaded) => {
        loaded.colorSpace = THREE.SRGBColorSpace;
        setTexture(loaded);
      },
      undefined,
      (err) => {
        console.error("[ImageWallMaterial] Failed to load image:", err);
      }
    );

    return () => {
      if (tex) tex.dispose();
    };
  }, [src]);

  if (!texture) {
    return <FallbackMaterial side={side} />;
  }

  return <meshStandardMaterial map={texture} side={side} />;
};

const ImageWallMaterial = ({ src, side }) => {
  if (!src) {
    return <FallbackMaterial side={side} />;
  }
  return <ImageWallMaterialInner src={src} side={side} />;
};

export default ImageWallMaterial;
